<template>
  <div class="contentPrintReport">
    <!-- <iframe
      ref="printIframe"
      class="hidden-iframe"
      name="printf"
      loading="lazy"
      allowfullscreen
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
// import { v4 as uuidv4 } from "uuid";

export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["SET_HTML_TO_PRINT"]),

    async newPrintReport(html) {
      return new Promise((resolve) => {
        const iframe = document.createElement("iframe");
        const isPdf = html.startsWith("blob:");
        let cleanupTimeout = null;
        let isCleanedUp = false;

        iframe.style.position = "absolute";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        iframe.style.left = "-9999px";

        document.body.appendChild(iframe);

        const cleanup = () => {
          if (isCleanedUp) return;

          isCleanedUp = true;
          iframe.onload = null;

          if (cleanupTimeout) clearTimeout(cleanupTimeout);
          if (isPdf) URL.revokeObjectURL(html);

          iframe.remove();
          resolve();
        };

        const doPrint = () => {
          const win = iframe.contentWindow;

          win.onafterprint = cleanup;

          win.focus();
          win.print();

          if (!isCleanedUp) {
            // Evita vazamento caso o navegador não dispare onafterprint,
            // sem remover o PDF enquanto o diálogo ainda está em uso.
            cleanupTimeout = setTimeout(cleanup, 1 * 60 * 1000);
          }
        };

        if (isPdf) {
          iframe.src = html;
          iframe.onload = () => {
            setTimeout(doPrint, 500); // dá tempo pro PDF viewer
          };
        } else {
          const doc = iframe.contentWindow.document;
          doc.open();
          doc.write(html);
          doc.close();

          setTimeout(doPrint, 100);
        }
      });
    },
  },
  computed: {
    ...mapState(["htmlToPrint"]),
  },
  watch: {
    async htmlToPrint(newValue) {
      if (newValue) {
        const contentToPrint = newValue;

        this.SET_HTML_TO_PRINT(null);

        await this.newPrintReport(contentToPrint);
      }
    },
  },
};
</script>

<style scoped>
.hidden-iframe {
  position: absolute;
  width: 0;
  height: 0;
  border: none;
  left: -9999px;
  z-index: -99999;
}
</style>
